import React, {useMemo, useState} from 'react'
import {RootState} from 'setup'
import {selectOrderDiscounts, setIsDirtyDiscount} from 'app/features/orders/redux/order/orderEditSlice'
import {useDispatch, useSelector} from 'react-redux'
import {Discount} from 'app/features/orders/componentsv1/shared/discount'
import EditDiscount from './EditDiscount'
import {Discount as DiscountType} from 'app/features/orders/models/OrderState'
import {simpleCurrency} from 'app/format/currency'

interface Props {}

export const WineClubDiscountAction: React.FC<Props> = () => {
  const dispatch = useDispatch()
  const discounts = useSelector<RootState, DiscountType>(selectOrderDiscounts)
  const [showDiscount, setShowDiscount] = useState(false)

  const wineClubDiscountTitle = useMemo(() => {
    // if (discounts && discounts.wineClubDiscounts > 0 && discounts.name) {
    //   return {btn: null, name: discounts.name}
    // }
    return {btn: 'Edit', name: 'Wine Club Discount'}
  }, [discounts])

  const handleOpen = () => {
    dispatch(setIsDirtyDiscount(true))
    if (discounts && discounts.wineClubDiscountCodeId) {
      setShowDiscount(true)
    }
  }

  const handleClose = () => {
    setShowDiscount(false)
  }

  return (
    <div>
      <Discount
        show={showDiscount}
        title={wineClubDiscountTitle}
        discountCodeId={discounts.wineClubDiscountCodeId}
        onClick={handleOpen}
        isWineClub
      >
        {showDiscount && (
          <EditDiscount
            onClose={handleClose}
            isWineClub
            title='Override Wine Club Discount'
            subTitle={`Customers current discount is ${simpleCurrency(
              discounts.wineClubDiscounts
            )}`}
            discountCodeId={discounts.wineClubCodeId}
          />
        )}
      </Discount>
    </div>
  )
}

export default WineClubDiscountAction
